import Vue from 'vue'
import VueRouter from 'vue-router'
import mainLayout from '@/views/htui/layout'


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/loginPage',
    component: () => import('@/views/components/loginPage'),
    name: 'loginPage'
  },

  {
    path: '',
    component: mainLayout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/htui/pages/index'),
        name: 'index'
      },

      {
        path: '/system',
        component: () => import('@/views/htui/pages/system/index'),
        name: 'system',
      },
      {
        path: '/warning',
        component: () => import('@/views/htui/pages/enterprise/warning'),
        name: 'warning',
        meta: {
          moduleType: 'enterprise' // 自定义特殊标识：区分企业模块
        },
      },
      {
        path: '/qualificationQuote',
        component: () => import('@/views/htui/pages/enterprise/qualificationQuote/index'),
        name: 'qualificationQuote',
        meta: {
          moduleType: 'enterprise'
        },
      },



      {
        path: '/customer',
        component: () => import('@/views/htui/EnterpriseLayout'),
        redirect: '/customer/overview',
        children: [
          {
            path: 'overview',
            component: () => import('@/views/htui/pages/enterprise/Overview'),
            name: 'customerOverview',
            meta: {
              moduleType: 'enterprise' // 自定义特殊标识：区分企业模块
            },
          },
          {
            path: 'manage',
            component: () => import('@/views/htui/pages/enterprise/CustomerManage'),
            name: 'customerManage',
            meta: {
              moduleType: 'enterprise' // 自定义特殊标识：区分企业模块
            },
          },
          {
            path: '/follow-up',
            component: () => import('@/views/htui/pages/enterprise/FollowUp'),
            name: 'follow-up',
            meta: {
              moduleType: 'enterprise' // 自定义特殊标识：区分企业模块
            },
          },
          {
            path: '/report',
            component: () => import('@/views/htui/pages/enterprise/Report'),
            name: 'report',
            meta: {
              moduleType: 'enterprise' // 自定义特殊标识：区分企业模块
            },
          }
        ]
      },
      {
        path: '/talent',
        component: () => import('@/views/htui/TalentLayout'),
        redirect: '/talent-overview',
        children: [
          {
            path: '/talent-overview',
            component: () => import('@/views/htui/pages/talent/TalentOverview'),
            name: 'talent-overview',
            meta: {
              moduleType: 'talent' // 自定义特殊标识：区分人才模块
            },
          },
          {
            path: '/talent-customer',
            component: () => import('@/views/htui/pages/talent/TalentCustomer'),
            name: 'talent-customer',
            meta: {
              moduleType: 'talent' // 自定义特殊标识：区分人才模块
            },
          },
          {
            path: '/talent-follow-up',
            component: () => import('@/views/htui/pages/talent/TalentFollowUp'),
            name: 'talent-follow-up',
            meta: {
              moduleType: 'talent' // 自定义特殊标识：区分人才模块
            },
          },
          {
            path: '/talent-todo',
            component: () => import('@/views/htui/pages/talent/TalentTodo'),
            name: 'talent-todo',
            meta: {
              moduleType: 'talent' // 自定义特殊标识：区分人才模块
            },
          },
          {
            path: '/talent-report',
            component: () => import('@/views/htui/pages/talent/Report'),
            name: 'talent-report',
            meta: {
              moduleType: 'talent' // 自定义特殊标识：区分人才模块
            },
          },
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

